import { Injectable } from '@angular/core';

@Injectable()
export class DetectTouchService {
  public isTouch() {
    return 'ontouchstart' in window;
  }
}
